// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-validation[data-v-7461af48]{padding:0.5rem;font-size:12px}.form-validation[data-v-7461af48]:empty{padding:0}\n", ""]);
// Exports
module.exports = exports;
